import React from 'react';
import { Modal } from '../../../../components';
import { SipProviderForm } from './SipProviderForm';
import { SIP_PROVIDER_LABELS } from '../constants';
import type { SipProviderFormData } from '../types';

interface SipProviderModalsProps {
  isOpened: boolean;
  onClose: () => void;
  isOpenedEditModal: boolean;
  onCloseEditModal: () => void;
  formValues: SipProviderFormData;
  setFormValues: (values: SipProviderFormData) => void;
  handleCreateProviderSubmit: (data: SipProviderFormData) => void;
  handleEditProviderSubmit: (data: SipProviderFormData) => void;
  creatingProvider: boolean;
  updatingProvider: boolean;
}

export const SipProviderModals: React.FC<SipProviderModalsProps> = ({
  isOpened,
  onClose,
  isOpenedEditModal,
  onCloseEditModal,
  formValues,
  setFormValues,
  handleCreateProviderSubmit,
  handleEditProviderSubmit,
  creatingProvider,
  updatingProvider,
}) => {
  return (
    <>
      <Modal
        size="small"
        open={isOpened}
        onClose={onClose}
        title={SIP_PROVIDER_LABELS.CREATE_PROVIDER}
      >
        <SipProviderForm
          formValues={formValues}
          setFormValues={setFormValues}
          onSave={handleCreateProviderSubmit}
          onCancel={onClose}
          loading={creatingProvider}
        />
      </Modal>

      <Modal
        size="small"
        open={isOpenedEditModal}
        onClose={onCloseEditModal}
        title={SIP_PROVIDER_LABELS.EDIT_PROVIDER}
      >
        <SipProviderForm
          formValues={formValues}
          setFormValues={setFormValues}
          isEdit
          onSave={handleEditProviderSubmit}
          onCancel={onCloseEditModal}
          loading={updatingProvider}
        />
      </Modal>
    </>
  );
};
